import React from "react";

export default () => {
  return (
    <>
      <h1>SkillsCom admin panel :)</h1>
    </>
  );
};
